import { render, staticRenderFns } from "./LaudoPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=template&id=5a219346&"
import script from "./LaudoPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=script&lang=js&"
export * from "./LaudoPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=script&lang=js&"
import style0 from "./LaudoPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VCard,VCol,VContainer,VIcon,VRow,VSelect,VTextField,VTextarea})
